import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../../login-service';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss'],
  providers:[LoginService]
})
export class AdminComponent implements OnInit {
  adminUserType:string;
displayDashboard:boolean=false;
user_type:string;
menuList:any;
selectedMenuIteam:string;
userID:string;
  rolesList: any;
  usersList: any;
  roleID: string;
  MenuPermissions: any;
  menuData: string;
constructor(private loginService:LoginService,private router: Router) { 
    this.user_type=localStorage.getItem("userType");
    this.userID=localStorage.getItem("userID");
    this.roleID=localStorage.getItem("roleID");
    this.MenuPermissions=localStorage.getItem("MenuPermissions");
    this.menuData=localStorage.getItem("menuData");
    this.adminUserType=localStorage.getItem("userTypeid");
    this.GetUsers();
    this.GetMenusByUserType(3);
   }


  ngOnInit(): void {
   
    this.GetRoles();
  }
  GetUsers(){
    this.loginService.GetUsers(this.adminUserType).subscribe(data=>
      {  
        data = JSON.parse(data['_body']);
              this.usersList=JSON.parse(JSON.stringify(data));
              
              
      });
  }
LogoutAdmin(){
  localStorage.removeItem('roleID');
    localStorage.removeItem('userID');
    localStorage.removeItem('userType');
    localStorage.removeItem('MenuPermissions');
    localStorage.removeItem('menuData');
  this.router.navigateByUrl("/admin");
}
  GetRoles(){
    this.loginService.GetRoles(this.adminUserType).subscribe(data=>
      {  
        data = JSON.parse(data['_body']);
              this.rolesList=JSON.parse(JSON.stringify(data));
  let filteRole=this.rolesList.filter(x=>x.RoleID.toString()==this.roleID.toString())

  if(filteRole.length>0){
    this.MenuPermissions=JSON.parse(filteRole[0].MenuJson);
  }
  });
  }
  DisplayLoc(){
    this.displayDashboard=true;
  }

  menuClick(url, obj,menuName) {
    var activeclasses = document.querySelectorAll('.liactive');
    for (let i = 0; i < activeclasses.length; i++) {
      activeclasses[i].setAttribute("class", "liactive1");
      activeclasses[i].parentElement.setAttribute("class", "has-module1");
    }
    obj.parentNode.setAttribute("class", "liactive");
    obj.parentNode.parentNode.setAttribute("class", "has-module");
    this.selectedMenuIteam=menuName;
    this.router.navigate([url]);
  }

  displayAdm(){
    this.displayDashboard=false;
  }
  GetMenusByUserType(userTypeID){
    this.loginService.GetMenusByUserType(userTypeID).subscribe(data=>
        {
    
    data = JSON.parse(data['_body']);
    this.menuList=JSON.parse(JSON.stringify(data));
    
        });
        }

}
